import {
  ExecuteTextPromptQuery,
  ExecuteTextPromptQueryVariables,
} from '../__generated__/queries-web';
import { client } from '../apollo';
import { EXECUTE_TEXT_PROMPT } from '../apollo/queries/execute-text-prompt.web.graphql';

export const callOpenAI = async (
  content: string,
  maxCompletionTokens?: number,
  temperature?: number,
) => {
  return await client.query<
    ExecuteTextPromptQuery,
    ExecuteTextPromptQueryVariables
  >({
    fetchPolicy: 'no-cache',
    query: EXECUTE_TEXT_PROMPT,
    variables: {
      prompt: content,
      max_completion_tokens: maxCompletionTokens,
      temperature,
      response_format: {
        type: 'json_object',
      },
    },
  });
};
